import { getLogger } from '../utils/DebugUtils';
import useRecursiveTimeout from './useRecursiveTimeout';
export function usePollForChat(almeAppConfig, isInitialized, almeState, apiUtils) {
    useRecursiveTimeout(async () => {
        const shouldPoll = almeAppConfig.notificationApi.pollForLiveChat && isInitialized.current && almeState.isOpen;
        if (shouldPoll) {
            try {
                await apiUtils.getLiveChatNotifications();
            }
            catch (ex) {
                getLogger(almeAppConfig.UiLogLevel).error('getLiveChatNotifications error: ', ex);
            }
        }
    }, almeState.isLiveChatConnected ? almeAppConfig.notificationApi.liveChatInterval.connected : almeAppConfig.notificationApi.liveChatInterval.disconnected);
}
